// No IE11/core-js polyfills: the build targets esnext, so a browser that needed them could not
// parse the bundle anyway, and they were ~700 KB of the entry chunk.
// The router lives under /dashboard. nginx serves the app for every path, so a link to
// /register (website, old mails) rendered an empty page. Move such paths under the
// basename before the router starts; query and hash (ad click ids!) travel along.
if (!/^\/dashboard(\/|$)/.test(window.location.pathname) && window.location.pathname !== '/') {
  window.location.replace(`/dashboard${window.location.pathname}${window.location.search}${window.location.hash}`);
}
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import ReactDOM from 'react-dom/client';
// Vor App: fängt Chromes einmaliges „installierbar“-Ereignis ab (siehe pwa-install-event.ts).
import 'utils/pwa-install-event';
import App from './App';
import config from './config';
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Pages are loaded on demand. After a deploy an open tab still asks for the old chunk names,
// which no longer exist (nginx answers 404): reload once to pick up the new build instead of
// showing an error. The timestamp keeps a genuinely broken chunk from reloading in a loop.
window.addEventListener('vite:preloadError', (event) => {
  const last = Number(sessionStorage.getItem('pai-chunk-reload') || 0);
  if (Date.now() - last < 10_000) return;
  sessionStorage.setItem('pai-chunk-reload', String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

// PWA: the service worker (public/sw.js) caches the hashed bundle for the next visit and lets
// the installed app open. Production only; a dev server must never be served from a cache.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/dashboard/sw.js', { scope: '/dashboard/' }).catch(() => {});
  });
}

// Set logger level when not in production
if (import.meta.env.DEV) {
  const loggerBaseString: string = config.loggerBaseString || 'dashboard-react';
  localStorage.setItem('debug', `${loggerBaseString}:*`);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
